module.exports = __webpack_public_path__ + "assets/iphone@2x.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/devices/iphone@2x.png
// module id = 440
// module chunks = 19